import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { CloseIcon } from 'components/modals/components/close'

export const ModalHeader = styled.div`
  display: flex;
  margin-bottom: 20px;

  @media (max-width: 525px) {
    justify-content: center;
  }
`

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 525px) {
    align-items: center;
  }
`

export const ModalFooter = styled.div`
  display: flex;
  padding-top: 20px;
  ${props => props.center ? 'justify-content: center;' : ''}

  @media (max-width: 525px) {
    align-items: center;
  }
`

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 40px;
  width: ${props => props.sm ? 500 : 800}px;
  max-width: 100%;
`

export default function ModalLayout ({ setOpen, showClose, children }) {
  const onClose = () => setOpen(false)

  return (
    <Wrapper data-test="modal">
      { showClose
        ? <CloseIcon onClick={onClose} data-test="close">
            <img className="flex" src="/s/icons/modal-close.svg" alt="Close modal" />
          </CloseIcon>
        : null }
      { children || null }
    </Wrapper>
  )
}

ModalLayout.propTypes = {
  showClose: PropTypes.bool,
  setOpen: PropTypes.func,
  children: PropTypes.any
}
